import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../../../store";
import EASkeletonLoader from "../../../shared/EASkeletonLoader";
import CardDescription from "../../../MyAccount/AccountCard/CardDescription";
import getDelphiNumber from "../../../../../utils/getDelphiNumber";
import QRCode from "react-qr-code";
import CardBalance from "../../../MyAccount/AccountCard/CardBalance";
import { Link } from "react-router-dom";
import EAButton from "../../../shared/Buttons/EAButton";
import { AiOutlineSafety } from "react-icons/ai";
import { format } from "date-fns";
import { ECARD_RECHARGE } from "../../../../routes";
import "./EcardTab.scss";
import useFacility from "../../../../../utils/hooks/useFacility";
import EADivider from "../../../shared/EADivider";

const EcardCard: React.FC = () => {
  const { t } = useTranslation();
  const facilityId = useFacility();
  const userData = useSelector((state: State) => state.auth.userData);
  const loading = useSelector((state: State) => state.auth.loading);
  const ecardQr = useSelector((state: State) => state.config.configuration.ecard_showBarCode);
  const ecardRegisterIncome = useSelector((state: State) => state.config.configuration.ecard_RegisterIncome);

  // Sprawdzenie czy data minęła
  const isCardExpired = userData.closeDate && new Date(userData.closeDate).getTime() < new Date().getTime();
  const isFacility273 = facilityId === "273";
  const showCashierOnlyMessage = isCardExpired && isFacility273;

  return (
    <>
      {loading ? (
        <EASkeletonLoader height="300px" />
      ) : (
        <>
          <div className="ecard-card">
            <div className="ecard-card-box">
              <div className="ecard-card-deposit">
                <div className="ecard-card-deposit-left">
                  <p className="ecard-card-deposit-title text-color-dark-gray">{t("dostepne_srodki")}</p>
                  <CardBalance />
                </div>
                {ecardRegisterIncome && (
                  <div className="ecard-card-deposit-right">
                    {showCashierOnlyMessage ? (
                      <span className="caption text-color-gray">Doładowanie możliwe tylko w kasie.</span>
                    ) : (
                      <Link to={ECARD_RECHARGE}>
                        <EAButton title={t("doladuj_karte")} startIcon={<AiOutlineSafety />} />
                      </Link>
                    )}
                  </div>
                )}
              </div>

              <EADivider />

              <div className="ecard-card-up flex-between">
                <div className="ecard-card-up-left">
                  <div className="ecard-card-info-row">
                    <div className="ecard-card-info-item">
                      <p className="ecard-card-info-label text-color-dark-gray">{t("upust")}</p>
                      <p className="ecard-card-info-value text-bold text-color-dark">
                        <CardDescription />
                      </p>
                    </div>

                    <div className="ecard-card-info-item">
                      <p className="ecard-card-info-label text-color-dark-gray">{t("waznosc")}</p>
                      <p className="ecard-card-info-value text-bold text-color-dark">
                        {userData.closeDate ? <>{format(userData.closeDate, "dd.MM.yyyy")}r.</> : <>{t("brak")}</>}
                      </p>
                    </div>
                  </div>
                </div>
                {ecardQr && (
                  <div className="qr flex-center-center flex-column">
                    <QRCode value={`EA_${getDelphiNumber(userData.account)}`} size={100} />
                    <b>{`EA_${getDelphiNumber(userData.account)}`}</b>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default EcardCard